import React from 'react';
import { FaInstagram, FaYoutube, FaWhatsapp, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { FaTiktok } from 'react-icons/fa6';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-content container">
                <div className="footer-grid">
                    <div className="footer-column">
                        <div className="footer-logo">
                            <span className="logo-text">
                                SA <span className="gradient-text">Visa</span>
                            </span>
                            <span className="logo-subtitle">Consultants</span>
                        </div>
                        <p className="footer-description">
                            Your trusted partner in achieving global education dreams.
                            We provide comprehensive support for students aspiring to study abroad.
                        </p>
                        <div className="social-links">
                            <a href="https://www.tiktok.com/@savisaconsultant" className="social-icon" aria-label="TikTok" target="_blank" rel="noopener noreferrer">
                                <FaTiktok />
                            </a>
                            <a href="https://www.instagram.com/savis_aconsultant/" className="social-icon" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                                <FaInstagram />
                            </a>
                            <a href="https://youtube.com/@savisaconsultant" className="social-icon" aria-label="YouTube" target="_blank" rel="noopener noreferrer">
                                <FaYoutube />
                            </a>
                            <a href="https://wa.me/96895249020" className="social-icon" aria-label="WhatsApp" target="_blank" rel="noopener noreferrer">
                                <FaWhatsapp />
                            </a>
                        </div>
                    </div>

                    <div className="footer-column">
                        <h4>Quick Links</h4>
                        <ul className="footer-links">
                            <li><a href="#home">Home</a></li>
                            <li><a href="#about">About Us</a></li>
                            <li><a href="#services">Services</a></li>
                            <li><a href="#team">Team</a></li>
                            <li><a href="#destinations">Destinations</a></li>
                            <li><a href="#contact">Contact</a></li>
                        </ul>
                    </div>

                    <div className="footer-column">
                        <h4>Study Destinations</h4>
                        <ul className="footer-links">
                            <li><a href="#uk">United Kingdom</a></li>
                            <li><a href="#usa">United States</a></li>
                            <li><a href="#canada">Canada</a></li>
                            <li><a href="#australia">Australia</a></li>
                            <li><a href="#germany">Germany</a></li>
                            <li><a href="#newzealand">New Zealand</a></li>
                        </ul>
                    </div>


                    <div className="footer-column">
                        <h4>Contact Info</h4>
                        <ul className="footer-contact">
                            <li>
                                <FaMapMarkerAlt className="contact-icon" />
                                <span>Muscat, Oman <span className="flag-badge">🇴🇲</span></span>
                            </li>
                            <li>
                                <FaPhone className="contact-icon" />
                                <span>+968 95249020<br />+968 78095244</span>
                            </li>
                            <li>
                                <FaEnvelope className="contact-icon" />
                                <span>savisaconsultant080@gmail.com</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {currentYear} SA Visa Consultants. All rights reserved.</p>
                    <div className="footer-bottom-links">
                        <a href="#privacy">Privacy Policy</a>
                        <span className="divider">|</span>
                        <a href="#terms">Terms of Service</a>
                        <span className="divider">|</span>
                        <span>Powered by <a href="https://dotandcrosstechnology.com" target="_blank" rel="noopener noreferrer" className="powered-by-link">Dot and Cross Technology</a></span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
